"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseResultMapper = void 0;
class ExerciseResultMapper {
    mapFromGenerated(generated) {
        return {
            ...generated,
            respondedAt: generated.respondedAt ? new Date(generated.respondedAt) : new Date(),
        };
    }
    mapToGenerated(exerciseResult) {
        return exerciseResult;
    }
}
exports.ExerciseResultMapper = ExerciseResultMapper;
//# sourceMappingURL=exercise-result.mapper.js.map